var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4859 2.82568C11.4859 3.23698 11.8168 3.56787 12.2281 3.56787H15.3855L8.48624 10.464C8.19555 10.7547 8.19555 11.2248 8.48624 11.5124C8.77693 11.8 9.24698 11.8031 9.53458 11.5124L16.4307 4.61621V7.7736C16.4307 8.1849 16.7616 8.51579 17.1729 8.51579C17.5842 8.51579 17.9151 8.1849 17.9151 7.7736V2.82568C17.9151 2.41439 17.5842 2.0835 17.1729 2.0835H12.2281C11.8168 2.0835 11.4859 2.41439 11.4859 2.82568ZM4.31143 3.07308C3.08064 3.07308 2.08487 4.06885 2.08487 5.29964V15.6903C2.08487 16.9211 3.08064 17.9168 4.31143 17.9168H14.7021C15.9328 17.9168 16.9286 16.9211 16.9286 15.6903V11.7319C16.9286 11.3206 16.5977 10.9897 16.1864 10.9897C15.7751 10.9897 15.4442 11.3206 15.4442 11.7319V15.6903C15.4442 16.1016 15.1134 16.4325 14.7021 16.4325H4.31143C3.90014 16.4325 3.56924 16.1016 3.56924 15.6903V5.29964C3.56924 4.88835 3.90014 4.55745 4.31143 4.55745H8.26976C8.68106 4.55745 9.01195 4.22656 9.01195 3.81527C9.01195 3.40397 8.68106 3.07308 8.26976 3.07308H4.31143Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.bde00d094b30603f535a5b04a448cc09.svg";
export { ForwardRef as ReactComponent };